/* N.B. These codes need to reflect app/src/Entity/ProblemStatus.php in the api project */
const PROBLEM_STATUS = {
  DRAFT: 0,
  IN_PROCESSING: 30,
  COMPLETE: 50,
};

export default PROBLEM_STATUS;
